import { FC, useEffect, InputHTMLAttributes } from 'react'
import { useFormContext } from 'react-hook-form'
import styles from 'components/features/future/FutureCheckbox/FutureCheckbox.styl'
import { Omit } from 'interfaces'
import cn from 'classnames'
import { AnyRegisterType } from 'interfaces/form'

type FutureCheckboxProps =
  & Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'name'>
  & {
    register?: AnyRegisterType
    name?: string
  }

export const FutureCheckbox: FC<FutureCheckboxProps> = (props) => {
  const { name, register, className, ...restProps } = props
  const fieldProps = !!name && !!register ? register(name) : { ...restProps, name }


  return (
    <label className={ cn(styles.futureCheckbox, className) }>
      <input { ...fieldProps } className={ styles.input } type='checkbox' />
      <div className={ styles.ui } />
    </label>
  )
}

type FutureCheckboxControllerProps =
  & Omit<FutureCheckboxProps, 'register' | 'name'>
  & {
    name: string
  }
export const FutureCheckboxController: FC<FutureCheckboxControllerProps> = (props) => {
  const { name, ...restProps } = props
  const { register, unregister } = useFormContext<Record<string, any>>()

  useEffect(() => {
    return () => {
      unregister(name)
    }
  }, [unregister, name])

  return (
    <FutureCheckbox { ...restProps } name={ name } register={ register } />
  )
}
